namespace GeniuzPOS.RefundReasonReport {
    export class ReportRefundReasonSumBillColumns {
        static columnsKey = 'RefundReasonReport.ReportRefundReasonSumBill';
    }
}
